import { render, staticRenderFns } from "./InputDateOfBirth.vue?vue&type=template&id=1283e54d"
import script from "./InputDateOfBirth.vue?vue&type=script&lang=ts"
export * from "./InputDateOfBirth.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports